import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetFieldsLocationsQuery } from 'services/api/Meteorology/Fields/TrackingForecast/Register';

export default function useLocations() {
  const { data, error } = useGetFieldsLocationsQuery();

  useHandleRequestErrors(error as unknown as ResponseError);

  return { locations: data };
}
